import api from '@/api'
import store from '@/store'

export default {
  paginate(page, perPage, keyword = '') {
    return new Promise(function (resolve, reject) {
      api
        .request('get', `/api/v1/clients?page=${page}&per_page=${perPage}&keyword=${keyword}`, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  getAllClients(force) {
    return new Promise(function (resolve, reject) {
      const cacheClientList = store.state.cache.clientList

      if (cacheClientList.data !== null && force === false) {
        resolve(cacheClientList)
      } else {
        api
          .request('get', '/api/v1/clients/all', true)
          .then(response => {
            if (response.status !== 200) {
              reject(response)
              return
            }

            // Save to Vuex store
            store.commit('SET_CLIENTS', response.data)

            resolve(store.state.cache.clientList)
          })
          .catch(error => {
            // Request failed.
            reject(error)
          })
      }
    })
  },
  // Get All Client Deal Natures
  getAllClientDealNatures(force) {
    return new Promise(function(resolve, reject) {
      api
        .request('get', '/api/v1/clients/deal/natures', true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  getClientGroups() {
    return new Promise(function (resolve, reject) {
      api
        .request('get', '/api/v1/clients/groups', true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  getClient(clientID) {
    return new Promise(function (resolve, reject) {
      api
        .request('get', '/api/v1/clients/' + clientID, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  getClientUser(clientID) {
    return new Promise(function (resolve, reject) {
      api
        .request('get', '/api/v1/clients/' + clientID + '/users', true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  createClient(client) {
    return new Promise(function (resolve, reject) {
      api
        .request('post', '/api/v1/clients', true, client)
        .then(response => {
          if (response.status !== 201) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  addClientGroup(clientGroup) {
    return new Promise(function (resolve, reject) {
      api
        .request('post', '/api/v1/clients/groups/add', true, clientGroup)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  editClient(client, clientId) {
    // const clientID = client.id
    // delete client.id

    return new Promise(function (resolve, reject) {
      api
        .request('patch', '/api/v1/clients/' + clientId, true, client)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  updateClientUser(client) {
    const clientID = client.userClient.clientID
    // delete client.userClient.clientID

    return new Promise(function (resolve, reject) {
      api
        .request('post', '/api/v1/clients/' + clientID + '/users', true, client)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  updateClient(data) {
    let {
      clientID,
      clientInfoFormData
    } = data
    return new Promise(function (resolve, reject) {
      api
        .request('patch', '/api/v1/clients/' + clientID, true, clientInfoFormData)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  updateClientLogo(data) {
    let {
      clientID,
      body
    } = data

    return new Promise(function (resolve, reject) {
      api
        .request('patch', '/api/v1/clients/' + clientID + '/logo', true, body)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  deleteClient(clientID) {
    return new Promise(function (resolve, reject) {
      api
        .request('delete', '/api/v1/clients/' + clientID, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  deleteClientGroup(groupID) {
    return new Promise(function (resolve, reject) {
      api
        .request('delete', '/api/v1/clients/groups/' + groupID, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  getCampaignsForClient(options) {
    const params = Object.keys(options)
      .map(key => `${key}=${options[key]}`)
      .join('$')
    return new Promise(function (resolve, reject) {
      const url = `/api/v1/campaigns?${params}`
      api
        .request('get', url, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // Get Client Account Summary of current Usage
  async getClientAccountSummary(clientID) {
    try {
      let response = await api.request('get', `/api/v1/clients/summary/${clientID}`, true)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  getClientsByAssignedID(data) {
    return new Promise(function (resolve, reject) {
      api
        .request('post', '/api/v1/clients/count/by/assigned-id', true, data)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  // Send Email Notification when client accepted vendor creation form
  async clientVendorCreationFormAcceptedEmail(data) {
    try {
      let url = `/api/v1/posts/client/vendor-creation-form/notify`
      let response = await api.request('post', url, true, data)
      if (response.status !== 200) {
        throw new Error('Error')
      }
      return response.data
    } catch (error) {
      throw error
    }
  },
  sendDeleteReq(data, clientId) {
    return new Promise(function (resolve, reject) {
      api
        .request('patch', '/api/v1/clients/' + clientId + '/send-delete-req', true, data)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.status)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/views/Client/clientAPIs.js